import A4Fit from "@/modules/print/a4-fit";
import PrintPreviewShell from "@/modules/print/print-preview-shell";
import QuoteDocument from "@/modules/print/quote-document";
import type { QuotePrintView } from "@buildpy/core/views/g1b/quote-print";

// 견적 인쇄 화면 — 레이아웃을 벗어날 수 없는 경로라 PrintPreviewShell 이 셸을 덮는다.
const Page = ({ data: view }: { data: QuotePrintView }) => {
  const { quote, data, liveOrg } = view;

  return (
    <PrintPreviewShell
      closeHref={`/app/quotes/${quote.id}`}
      subtitle={quote.title}
      title={`${quote.quote_no} v${quote.version}`}
    >
      <A4Fit>
        <QuoteDocument data={data} org={liveOrg ?? undefined} />
      </A4Fit>
    </PrintPreviewShell>
  );
};

export default Page;
